import React from 'react';

interface TableRow {
  left: string;
  right: string;
}

interface TwoColumnTableProps {
  headerLeft: string;
  headerRight: string;
  rows: TableRow[];
  margin?: [string, string, string, string];
  columnWidths?: [string, string];
}

export const TwoColumnTable: React.FC<TwoColumnTableProps> = ({
  headerLeft,
  headerRight,
  rows,
  margin = ['0', 'auto', '0', 'auto'],
  columnWidths = ['50%', '50%'],
}) => {
  const [marginTop, marginRight, marginBottom, marginLeft] = margin;

  return (
    <div
      className='w-full h-full overflow-hidden rounded-2xl flex flex-col justify-start items-start break-words'
      style={{
        margin: `${marginTop} ${marginRight} ${marginBottom} ${marginLeft}`,
      }}
    >
      <div className='w-full bg-[#3f4c61] rounded-t-2xl flex justify-start items-center gap-8 py-6 px-6 min-[421px]:px-10'>
        <div
          className='flex flex-col justify-center text-white text-base font-semibold leading-[19.2px] break-words'
          style={{ flexBasis: columnWidths[0] }}
        >
          {headerLeft}
        </div>
        <div
          className='flex flex-col justify-center text-white text-base font-semibold leading-[19.2px] break-words'
          style={{ flexBasis: columnWidths[1] }}
        >
          {headerRight}
        </div>
      </div>

      {rows.map((row, index) => (
        <div
          key={index}
          className={`w-full py-6 flex justify-start items-center gap-8 px-6 min-[421px]:px-10 break-words ${
            index % 2 === 0 ? 'bg-[#f6f7f9]' : 'bg-[#edeff2]'
          }`}
        >
          <div
            className='text-[#262626] text-base font-semibold leading-[19.2px] break-words'
            style={{ flexBasis: columnWidths[0] }}
          >
            {row.left}
          </div>
          <div
            className='flex flex-col justify-center text-[#262626] text-base font-semibold leading-[19.2px] break-words'
            style={{ flexBasis: columnWidths[1] }}
          >
            {row.right}
          </div>
        </div>
      ))}
    </div>
  );
};
